/**
 * In the localstorage, a key 'accountStateByAddress' will store a JSON object explaining
 * the current state of the accountState.
 * Some part of the accountState are fetched from the blockchain, some other are fetched from the API,
 * and a few are stored in the localstorage.
 * This is the localstorage part.
 */

interface WaitlistStorageState {
  whitelistOfferPopupHasBeenShown: boolean
  waitlistOfferPopupHasBeenShown: boolean
  //xpBonusPopupHasBeenShown: boolean
}

/** This state depends on the user address
 * There will be as many WaitListState as there are addresses
 */
interface WaitlistStateByAddress {
  [address: string]: WaitlistStorageState
}

function getWaitlistStateForAllAddresses(): WaitlistStateByAddress {
  const waitlistStateByAddress = localStorage.getItem('accountStateByAddress')
  if (waitlistStateByAddress) {
    return JSON.parse(waitlistStateByAddress)
  } else {
    return {}
  }
}

export function getWaitlistState(address: string): WaitlistStorageState {
  const waitlistStateByAddress = getWaitlistStateForAllAddresses()
  if (waitlistStateByAddress[address]) {
    return waitlistStateByAddress[address]
  } else {
    return {
      whitelistOfferPopupHasBeenShown: false,
      waitlistOfferPopupHasBeenShown: false,
      //xpBonusPopupHasBeenShown: false,
    }
  }
}

function saveWaitlistStateForAddress(
  address: string,
  waitlistState: WaitlistStorageState
) {
  const waitlistStateByAddress = getWaitlistStateForAllAddresses()
  waitlistStateByAddress[address] = waitlistState
  localStorage.setItem(
    'accountStateByAddress',
    JSON.stringify(waitlistStateByAddress)
  )
}

export function storeWaitlistPopupHasBeenShown(address: string) {
  const waitlistState = getWaitlistState(address)
  waitlistState.waitlistOfferPopupHasBeenShown = true
  saveWaitlistStateForAddress(address, waitlistState)
}

export function storeWhitelistPopupHasBeenShown(address: string) {
  const waitlistState = getWaitlistState(address)
  waitlistState.whitelistOfferPopupHasBeenShown = true
  saveWaitlistStateForAddress(address, waitlistState)
}

/*
function cancelWhitelistPopupHasBeenShown(address: string) {
  const waitlistState = getWaitlistState(address)
  waitlistState.whitelistOfferPopupHasBeenShown = false
  saveWaitlistStateForAddress(address, waitlistState)
}

export function afterCancelWhitelistPopupHasBeenShown(
  accountState: AccountState
) {
  const address = accountState.address!
  cancelWhitelistPopupHasBeenShown(address)
  const whitelistState = accountState.whitelistState
  return {
    ...accountState,
    whitelistState: {
      ...whitelistState!,
      offerPopupShown: false,
    },
  }
}*/

/*
let lastPropositionToAddContact = 0
export function proposeToAddContact(address: string) {
  // We have a 2 seconds delay between each proposition
  const now = new Date().getTime()
  if (now - lastPropositionToAddContact < 1000 * 2) {
    return
  }
  lastPropositionToAddContact = now

  const waitlistState = getWaitlistState(address)
  waitlistState.proposedAddContact++
  saveWaitlistStateForAddress(address, waitlistState)
}*/
